import Card from "../../../../components/UI/Card";
import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {useParams} from "react-router-dom";
import CouponCode from "../coupon/CouponCode";
import Button from "../../../../components/UI/Button";
import {checkFeatureAvailability} from "../../../../util/helper";

const OrderSummaryComponent = ({setValue, control, errors, getValues, register, watch}) => {

  const {products} = useSelector(state => state.orders.orderForm);
  const {orderForm} = useSelector(state => state.orders);
  const [orderSummary, setOrderSummary] = useState({total:0, subTotal: 0, discount: 0, shippingCost: 0, free_shipping_by: ''})
  const [coupon, setCoupon] = useState(null)
  const params = useParams()


  useEffect(()=>{
    if(params && params.id && orderForm){
      if(orderForm.couponCode){
        setCoupon(orderForm.couponCode)
      }
      setOrderSummary({
        total:orderForm.total,
        subTotal: orderForm.sub_total,
        discount: orderForm.discount,
        shippingCost: orderForm.free_shipping ? 0 : orderForm.shipping_cost,
        free_shipping_by: orderForm.free_shipping ? orderForm.free_shipping_by : '',
      })
    }
  }, [params, orderForm])


  useEffect(()=>{
    if(!orderForm.free_shipping ) {
      setOrderSummary(rows => ({...rows, shippingCost: +getValues('shipping_cost')}))
    }
  }, [watch('shipping_method_id')])

  useEffect(()=>{
    calculator()
  }, [products, orderSummary.discount, orderSummary.shippingCost])

  useEffect(()=>{
    discountCalculator()
  }, [coupon, orderSummary.subTotal])

  const calculator = () => {
    let subTotal = 0
    products.map(item => {
      subTotal += (item.quantity * item.price)
    })
    let total = subTotal
    total = total + orderSummary.shippingCost
    if(orderSummary.discount <= subTotal){
      total = total - orderSummary.discount
    }
    setValue('discount', orderSummary.discount)
    setOrderSummary(rows => ({...rows, subTotal: subTotal, total: total}))

  }

  const discountCalculator = ()=>{
    if(coupon && coupon.minimum_amount < orderSummary.subTotal) {
      if (coupon.free_shipping) {
        setOrderSummary(rows => ({...rows, shippingCost: 0, free_shipping_by: `Free by coupon`}))
      }
      if(coupon.coupon.type === 'fixed'){
        console.log('55')
        setOrderSummary(rows => ({...rows, discount: coupon.coupon.amount_off}))
      } else if(coupon.coupon.type === 'percentage'){
        console.log('subtotal', orderSummary.subTotal)

        let discount = (orderSummary.subTotal * coupon.coupon.percentage_off / 100)

        console.log(coupon)
        setOrderSummary(rows => ({...rows, discount: discount}))
      }

    }
  }


  return(
    <Card cardBodyCls={`${params && params.id ? 'pb_0' : ''}`}>
      <h1 className="common_sub_title d_flex_btwn mt_0 mb_5">
        <span>Order Summary</span>
      </h1>
      <div className="checkout_summery">
        {!checkFeatureAvailability(orderForm, 'coupon', params) ?
          <>
            <table className={`table border_none mb_0`}>
              <tbody>
              <tr>
                <td className={"text_left"}>Sub Total</td>
                <td className={"text_right color_grey"}>${orderSummary.subTotal ? orderSummary.subTotal.toFixed(2) : '00.00'}</td>
              </tr>
              <tr>
                <td className={"text_left"}>Shipping Cost</td>
                <td className={"text_right color_grey"}>
                  {orderForm.free_shipping ? <span className={'text_red mr_5'}>Free </span> : ''}
                  ${orderSummary.shippingCost ? orderSummary.shippingCost.toFixed(2) : '00.00'}
                </td>
              </tr>
              <tr>
                <td>Discount {orderForm.coupon_code && <Button text={`Code: ${orderForm.coupon_code}`} classes={'has_border_radius'} size={'btn_sm'} /> } </td>
                <td className="text_right color_danger">- ${orderSummary.discount ? orderSummary.discount.toFixed(2) : '0.00'}</td>
              </tr>
              <tr>
                <td className={"text_left"}>Total</td>
                <td className="text_right font_16p"><b>${orderSummary.total ? orderSummary.total.toFixed(2) : '00.00'}</b></td>
              </tr>
              </tbody>
            </table>
          </>
          :
          <>
            <table className={`table mb_0`}>
              <tbody>
              <tr>
                <td className={"text_left"}>Sub Total</td>
                <td className={"text_right color_grey"}>${orderSummary.subTotal ? orderSummary.subTotal.toFixed(2) : '00.00'}</td>
              </tr>
              <tr>
                <td className={"text_left"}>Shipping Cost</td>
                <td className={"text_right color_grey"}>
                  {orderForm.free_shipping ? <span className={'text_red mr_5'}>Free </span> : ''}
                  ${orderSummary.shippingCost ? orderSummary.shippingCost.toFixed(2) : '00.00'}
                </td>
              </tr>
              </tbody>
            </table>
            {/*<CouponCode setValue={setValue} register={register} errors={errors} getValues={getValues} applycoupon={setCoupon}/>*/}
            <table className="table total_table">
              <tbody>
              {orderSummary.discount ?
              <tr>
                <td className={"text_left"}>Discount {orderForm.coupon_code && <Button text={`Code: ${orderForm.coupon_code}`} classes={'has_border_radius'} size={'btn_sm'} /> } </td>
                <td className="text_right color_danger">- ${orderSummary.discount ? orderSummary.discount.toFixed(2) : '0.00'}</td>
              </tr> : ''
              }
              <tr>
                <td className={"text_left"}>Total</td>
                <td className="text_right font_16p"><b>${orderSummary.total ? orderSummary.total.toFixed(2) : '00.00'}</b></td>
              </tr>
              </tbody>
            </table>
          </>
        }
      </div>
    </Card>
  );
}

export default OrderSummaryComponent